// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { DEBT_OBLIGATIONS_SELECT_OPTIONS } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  HasOtherOutstandingLoanObligations,
  RulesetResult,
  ListObligationsOrUploadDebtScheduleAnswerIs,
} from '../rules';

class DebtScheduleRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const selectedUploadDebtSchedule =
      ListObligationsOrUploadDebtScheduleAnswerIs.setAnswer(
        DEBT_OBLIGATIONS_SELECT_OPTIONS.DEBT_SCHEDULE
      ).evaluate(data);
    const hasOtherOutstandingLoanObligations =
      HasOtherOutstandingLoanObligations.evaluate(data);

    if (hasOtherOutstandingLoanObligations && selectedUploadDebtSchedule) {
      return RulesetResult.REQUIRED;
    }

    return RulesetResult.HIDDEN;
  };
}

export default new DebtScheduleRuleset();
